import React from 'react';
import { CheckedList } from 'modules/Modals/old/FilterModal/components/CheckboxGroup';
import { CollapsedTab } from 'modules/Modals/old/FilterModal/components/CollapsedTab';
import { useHiddenFilters, FILTER_PAGES } from 'hooks';
import { dropEmptyFilterSections } from 'modules/Modals/old/FilterModal/utils/dropEmptyFilterSections';
import * as Styled from './styles';
import { VISIT_CHARACTERISTICS_TABS } from './constant';

const { hostname } = window.location;
const IsVaAccount = hostname?.split('.')[0] === 'va';

// Everything in this builder except Gambling and Hemp-Derived Cannabis Products is part of the
// "Assessment Results by Product Type" group that P20M-1308 hides.
const NON_PRODUCT_TYPE_TABS = ['Gambling', 'Hemp-Derived Cannabis Products'];

// Exposed so VisitsQueryBuilder can tell whether this tab has any visible content and hide the
// whole "Visit Characteristics and Outcomes" tab when it would be empty (e.g. a non-VA account
// without the assessment-results permission, which leaves no product-type or Gambling/Hemp tabs).
export const useAssessmentCharacteristicsTabs = () => {
  const { canViewAssessmentResults } = useHiddenFilters(FILTER_PAGES.ASSESSMENT);

  let filteredTabs = IsVaAccount
    ? VISIT_CHARACTERISTICS_TABS
    : VISIT_CHARACTERISTICS_TABS.filter((tab) => !NON_PRODUCT_TYPE_TABS.includes(tab.title));

  // P20M-1308 — drop the product-type tabs unless the user has the matching permission. Gambling and
  // Hemp-Derived Cannabis Products are not part of the hide list, so they remain.
  if (!canViewAssessmentResults) {
    filteredTabs = filteredTabs.filter((tab) => NON_PRODUCT_TYPE_TABS.includes(tab.title));
  }

  return dropEmptyFilterSections(filteredTabs);
};

function AssessmentCharacteristics() {
  const { canViewAssessmentResults } = useHiddenFilters(FILTER_PAGES.ASSESSMENT);
  const filteredTabs = useAssessmentCharacteristicsTabs();

  const getElement = (item) => {
    switch (item.type) {
      case 'double':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            {item.collapsed.map((elem) => (
              <CheckedList name={elem.field} options={elem.options} key={elem.id} />
            ))}
          </CollapsedTab>
        );
      case 'multiple':
        return (
          <CollapsedTab title={item.title} key={item.id}>
            {item.collapsed.map((elem) => (
              <Styled.FiltersContainer key={elem.id}>
                <Styled.FiltersTitle>{elem.title}</Styled.FiltersTitle>
                <CheckedList name={elem.field} options={elem.options} />
              </Styled.FiltersContainer>
            ))}
          </CollapsedTab>
        );
      default:
        return null;
    }
  };

  return (
    <Styled.Wrapper>
      {canViewAssessmentResults && <Styled.FiltersTitle>Assessment Results by Product Type </Styled.FiltersTitle>}
      {filteredTabs.map((item) => getElement(item))}
    </Styled.Wrapper>
  );
}

export default AssessmentCharacteristics;
